// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-layout .ant-layout-content[data-v-34380f21],.ant-layout .ant-layout-footer[data-v-34380f21]{background:#fff}.ant-layout .ant-btn[data-v-34380f21]:hover{opacity:.8}.ant-layout .ant-btn-primary[data-v-34380f21]{background:#9bb5c9;border-color:#9bb5c9}.fonts[data-v-34380f21]{height:100%}.fonts[data-v-34380f21],.fonts .fonts__header[data-v-34380f21]{background-color:#fff}.fonts .fonts__item--centered[data-v-34380f21]{text-align:center}", ""]);
// Exports
module.exports = exports;
